<script>
    import { onMount } from 'svelte';
    import riveWASMResource from '@rive-app/canvas/rive.wasm?url';
    import { RuntimeLoader } from '@rive-app/canvas';
    import { RIVE_ANIMATIONS } from '@src/utils/animations.js';

    onMount(() => {
        RuntimeLoader.setWasmUrl(riveWASMResource);
    });
</script>

<!--https://dev.to/alex_barashkov/optimization-techniques-for-rive-animations-in-react-apps-1a8p-->
<svelte:head>
    <link rel="preload" href={riveWASMResource} as="fetch" crossOrigin="anonymous" />
    <link rel="preload" href={RIVE_ANIMATIONS.WIN} as="fetch" crossOrigin="anonymous" />
    <link rel="preload" href={RIVE_ANIMATIONS.TOP_SLOT} as="fetch" crossOrigin="anonymous" />
    <link rel="preload" href={RIVE_ANIMATIONS.BONUS_TRANSITION} as="fetch" crossOrigin="anonymous" />
    <link rel="preload" href={RIVE_ANIMATIONS.BALL_SPIN} as="fetch" crossOrigin="anonymous" />
    <link rel="preload" href={RIVE_ANIMATIONS.CASH_REELS} as="fetch" crossOrigin="anonymous" />
    <link rel="preload" href={RIVE_ANIMATIONS.WHEEL_OF_FORTUNE} as="fetch" crossOrigin="anonymous" />
</svelte:head>
